<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow"> 
      
      <el-form :inline="true" class="demo-form-inline backborder1" size="small">
	      <el-form-item v-if="actionauth.base_product_cate_add=='true'">
	          <el-button type="warning"  @click="addClassDialog">新增分类</el-button>
            <el-button type="warning"  @click="getClassList">搜索</el-button>
	      </el-form-item>
      </el-form>
      
      <div class="backborder2"  style="margin-top:10px">
          <el-table :data="classlists" v-loading="classListLoading">
              <!--------- 二级分类 ------------>
              <el-table-column type="expand">
	              <template slot-scope="props">
		              <el-table :data="props.row.child" style="width: 100%">
						          <!---------- 三级分类 ----------->
		              	  <el-table-column type="expand">
		              	  	  <template slot-scope="twoprops">
		              	  	  	  <el-table :data="twoprops.row.child" style="width: 100%">		              	  	  	  	  
		              	  	  	  	  <!---------- 四级分类 ---------->
		              	  	  	  	  <el-table-column type="expand">
		              	  	  	  	      <template slot-scope="threeprops">
			              	  	  	  	  	  <el-table :data="threeprops.row.child" style="width: 100%">
			              	  	  	  	  	  	  <!----- 五级分类 ---------->
			              	  	  	  	  	  	  <el-table-column type="expand">
			              	  	  	  	  	  	  	  <template slot-scope="fourprops">
			              	  	  	  	  	  	  	  	  <el-table :data="fourprops.row.child" style="width: 100%">
			              	  	  	  	  	  	  	  	  	  <el-table-column prop="catname" label="小类名称"></el-table-column>
			              	  	  	  	  	  	  	  	  	  <el-table-column label="操作" width="150" v-if="actionauth.base_product_cate_edit=='true' || actionauth.base_product_cate_del=='true'">
                                                            <template slot-scope="fourcopesmall">
                                                                <el-button type="text" size="mini" @click="editClassDialog(fourcopesmall.row)" v-if="actionauth.base_product_cate_edit=='true'">编辑</el-button>
                                                                <el-button type="text" size="mini" @click="delClass(fourcopesmall.row)" v-if="actionauth.base_product_cate_del=='true'">删除</el-button>
                                                            </template>
                                                        </el-table-column>
			              	  	  	  	  	  	  	  	  </el-table>
			              	  	  	  	  	  	  	  </template>
			              	  	  	  	  	  	  </el-table-column>
			              	  	  	  	  	  
			              	  	  	  	  	  	  <el-table-column prop="catname" label="小类名称"></el-table-column>
                                            <el-table-column label="操作" width="150" v-if="actionauth.base_product_cate_edit=='true' || actionauth.base_product_cate_del=='true'">
                                              <template slot-scope="threescopesmall">
                                                  <el-button type="text" size="small" @click="editClassDialog(threescopesmall.row)" v-if="actionauth.base_product_cate_edit=='true'">编辑</el-button>
                                                  <el-button type="text" size="small" @click="delClass(threescopesmall.row)" v-if="actionauth.base_product_cate_del=='true'">删除</el-button>
                                              </template>
                                            </el-table-column>
			              	  	  	  	  	  </el-table>
		              	  	  	  	  	  </template>
		              	  	  	  	  </el-table-column>
		              	  	  	  	  
		              	  	  	  	  <el-table-column prop="catname" label="小类名称"></el-table-column>
                                  <el-table-column label="操作" width="150" v-if="actionauth.base_product_cate_edit=='true' || actionauth.base_product_cate_del=='true'">
                                    <template slot-scope="twoscopesmall">
                                        <el-button type="warning" size="mini" @click="editClassDialog(twoscopesmall.row)" v-if="actionauth.base_product_cate_edit=='true'">编辑</el-button>
                                        <el-button type="danger" size="mini" @click="delClass(twoscopesmall.row)" v-if="actionauth.base_product_cate_del=='true'">删除</el-button>
                                    </template>
                                  </el-table-column>
		              	  	  	  </el-table>
		              	  	  </template>
		              	  </el-table-column>
						 
		                  <el-table-column prop="catname" label="小类名称"></el-table-column>
		                  <el-table-column label="操作" width="150" v-if="actionauth.base_product_cate_edit=='true' || actionauth.base_product_cate_del=='true'">
			                  <template slot-scope="scopesmall">
			                      <el-button type="warning" size="mini" @click="editClassDialog(scopesmall.row)" v-if="actionauth.base_product_cate_edit=='true'">编辑</el-button>
			                      <el-button type="danger" size="mini" @click="delClass(scopesmall.row)" v-if="actionauth.base_product_cate_del=='true'">删除</el-button>
			                  </template>
		                  </el-table-column>
		              </el-table>
	              </template>
              </el-table-column>
              
              <el-table-column label="分类名称" prop="catname"></el-table-column>
              <el-table-column label="操作" width="180" v-if="actionauth.base_product_cate_edit=='true' || actionauth.base_product_cate_del=='true'">
	              <template slot-scope="scope">
	                  <el-button type="warning" size="mini" round  @click="editClassDialog(scope.row)" v-if="actionauth.base_product_cate_edit=='true'">编辑</el-button>
	                  <el-button type="" size="mini" round @click="delClass(scope.row)" v-if="actionauth.base_product_cate_del=='true'">删除</el-button>
	              </template>
              </el-table-column>
          </el-table>
      </div>
      
      <!------------------------add class---------------------->
      <el-dialog title="新增分类" :visible.sync="createClassDialog" width="30%">
          <el-form ref="createclass" :model="createclass" :rules="classrules" label-width="100px" size="small">
            <el-col :span="20">
              <el-form-item label="所属分类">
                <el-select v-model="createclass.parentid" placeholder="不选默认为一级分类">
                  <el-option label="不选择分类" value="0"></el-option>
                  <el-option v-for="(item,index) in categoryaddlistsearch" :label="item.catname" :value="item.id" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
            <el-col :span="22">
              <el-form-item label="分类名称" prop="catname">
                <el-input v-model="createclass.catname"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="createClassDialog = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="createClassLoading" @click="createClassSave">保 存</el-button>
          </div>
      </el-dialog>
      
      <el-dialog title="编辑分类" :visible.sync="updateClassDialog" width="30%">
          <el-form ref="updateclass" :model="updateclass" :rules="classrules" label-width="100px" size="small">
            <!--
            <el-col :span="20">
              <el-form-item label="所属分类">
                <el-select v-model="updateclass.parentid" placeholder="请选择大分类">
                  <el-option label="不选择分类" value="0"></el-option>
                  <el-option v-for="(item,index) in categoryaddlistsearch" :label="item.catname" :value="item.id" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            -->
            <el-col :span="22">
              <el-form-item label="分类名称" prop="catname">
                <el-input v-model="updateclass.catname"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="updateClassDialog = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="updateClassLoading" @click="updateClassSave">保 存</el-button>
          </div>
        </el-dialog>
      
  </div>
  </transition>   
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作功能权限
      url:this.GLOBAL.domain+"Product/index",
      transitionshow:true,
      classListLoading:false,
      classlists:[],
      updateClassDialog:false,
      createclass: {
        act:'addclass',
        token:this.$cookies.get('token'),
        catname:'',
        parentid:''
      },
      updateclass: {
        act:'editclass',
        token:this.$cookies.get('token'),
        id:'',
        catname:'',
        parentid:''
      },
      createClassDialog:false,
      bigclasslists:[],
      classrules: {
        catname: [
            { required: true, message: '请输入分类名称', trigger: 'blur' },
            { min: 1, max: 20, message: '长度在 1 到 20 个字符'}
        ]
      },
      categoryaddlistsearch:[],
      createClassLoading:false,
      updateClassLoading:false,
    }
  },
  
  mounted(){
  	  this.getactionauth();
	    this.getClassList(); //获取商品分类信息
	    this.getCategoryaddList(); //获取分类展示列表
	    this.getCategoryList();
  },
  
  methods:{
  	
  	/** 获取操作功能权限 **/
  	getactionauth() {
    	  var data =this.$cookies.get('actionauth');
    	  data=JSON.parse(data);
        this.actionauth=data;
    },
    
    /** 分类列表 **/
    getClassList(){
        this.classListLoading = true;
        var resource = this.$resource(this.url);
        resource.query({ act:'getclass',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.classListLoading = false;
	        }else{
	            this.classlists = JSON.parse(Base64.decode(res.data.Data));
              console.log(JSON.stringify(this.classlists));
	            this.classListLoading = false;
	        }
        }).catch((res) => {
            this.classListLoading=false;
        });
    },
    
    /** 显示编辑分类框 **/
    editClassDialog(item){
        this.updateClassDialog=true;
        this.getBigClassList();
        this.updateclass.id=item.id;
        this.updateclass.catname=item.catname;
        this.updateclass.parentid=item.parentid;
    },
    
    /** 删除 **/
    delClass(item){
        let title="该操作将永久删除分类："+item.catname+"，以及其下面的所有子分类，且该分级及下面所有子分类绑定的全部商品进行解绑，是否继续？";
        this.$confirm(title, '提示', { type: 'warning' }).then(() => {
        	  //向请求服务端删除
            var resource = this.$resource(this.url);
            resource.save({ act:'delclass',id: item.id,token:this.$cookies.get('token')}).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{
                    this.$message.success('删除成功');
                    this.getClassList(); //更新分类列表
                    this.getCategoryList(); //更新搜索分类
                }
            }).catch((res) => {
            	//this.$message.error(this.GLOBAL.errortext);
            });
        }).catch(() => {
        	
        });
    },
    
    /** 显示新增分类框 **/
    addClassDialog(){
      this.createClassDialog=true;
      this.getBigClassList();
    },
    
    /** 取出所有大类 **/
    getBigClassList(){
        var resource = this.$resource(this.url);
        resource.query({ act:'getbigclass',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.bigclasslists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
           
        });
    },
    
    /** 添加分类展示类表 **/
    getCategoryaddList(){
        var resource = this.$resource(this.url);
        resource.query({ act:'getaddcatelist',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.categoryaddlistsearch = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 新增分类 **/
    createClassSave(){
        //校验数据有效性
        this.$refs.createclass.validate((valid) => {
            if (valid) {
                this.createClassLoading=true;
                var resource = this.$resource(this.url);
                resource.save(this.createclass).then((res) => {
                    if(res.data.Result>0){
                    	if(res.data.Result=='70001') this.$router.push('/login')
	                    this.$message.error(res.data.Message);
	                    this.createClassLoading=false;
                    }else{
	                    this.$message.success(res.data.Message);	                    
	                    this.createclass.catname='';
	                    this.createclass.parentid='';	                    
	                    this.getClassList(); //更新分类列表
	                    this.getCategoryaddList(); //更新选择分类
	                    this.createClassDialog=false;
	                    this.createClassLoading=false;
                    }
                }).catch((res) => {
                    this.createClassDialog=false;
                    this.createClassLoading=false;
                });
            }else {
            	return false;
            }
        });
    },
    
    /** 编辑分类的保存 **/
    updateClassSave(){
        //校验数据有效性
        this.$refs.updateclass.validate((valid) => {
            if(valid) {
                this.updateClassLoading=true;
                var resource = this.$resource(this.url);
                resource.save(this.updateclass).then((res) => {
                    if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	                    this.$message.error(res.data.Message);
	                    this.updateClassLoading=false;
                    }else{
	                    this.$message.success(res.data.Message);
	                    this.updateClassDialog=false;
	                    this.updateClassLoading=false;
	                    this.getClassList();
	                    this.getCategoryaddList(); //更新选择分类
                    }
                }).catch((res) => {
                    this.$message.error(this.GLOBAL.errortext);
                    this.createClassDialog=false;
                    this.createClassLoading=false;
                });
            }else {
            	return false;
            }
        });
    },
    
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/inventory/Productcate.vue